import React from 'react';
import { cn } from '@/lib/utils';

interface PlayersSkeletonProps {
  count?: number;
}

const PlayersSkeleton: React.FC<PlayersSkeletonProps> = ({ count = 5 }) => {
  return (
    <div className="space-y-4 animate-pulse">
      {/* Filters Skeleton */}
      <div className="bg-dark-200 rounded-xl border border-dark-300 overflow-hidden transition-all duration-300 p-3">
        <div className="flex items-center mb-3">
          <div className="w-8 h-8 mr-2 bg-dark-300 rounded-full"></div>
          <div className="h-5 w-32 bg-dark-300 rounded-lg"></div>
        </div>
        
        <div className="space-y-3">
          {/* Search Bar */}
          <div className="relative">
            <div className="h-10 w-full bg-dark-300 rounded-lg"></div>
          </div>
          
          {/* Filter Buttons */}
          <div className="flex flex-wrap gap-2">
            {[1, 2, 3, 4].map(i => (
              <div key={i} className="h-9 w-20 bg-dark-300 rounded-lg"></div>
            ))}
          </div>
        </div>
      </div>

      {/* Player Cards */}
      {Array.from({ length: count }).map((_, index) => (
        <div 
          key={index}
          className="bg-dark-200 rounded-xl border border-dark-300 p-4"
        >
          <div className="flex flex-col sm:flex-row gap-4">
            {/* Left Column: Avatar + Basic Info */}
            <div className="flex items-start gap-4">
              <div className="w-16 h-16 bg-dark-300 rounded-full"></div>
              
              <div className="flex-1 min-w-0">
                <div className="h-6 w-32 bg-dark-300 rounded-lg mb-2"></div>
                <div className="h-4 w-24 bg-dark-300 rounded-lg mb-2"></div>
                <div className="h-4 w-40 bg-dark-300 rounded-lg mb-3"></div>
                
                {/* Sports Tags */}
                <div className="flex flex-wrap gap-2">
                  {[1, 2, 3].map(i => (
                    <div key={i} className="h-6 w-16 bg-dark-300 rounded-full"></div>
                  ))}
                </div>
              </div>
            </div>
            
            {/* Right Column: Actions */}
            <div className="flex flex-col sm:flex-row gap-2 mt-4 sm:mt-0 sm:ml-auto">
              <div className="h-10 w-24 bg-dark-300 rounded-lg"></div>
              <div className="h-10 w-24 bg-dark-300 rounded-lg"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PlayersSkeleton;